import React, {} from 'react';

//enums
import { EmbedType } from  '@/interfaces/widgetPanel';

//components
import YouTubePreview from './Youtube/YoutubePreview';
import GiphyPreview from './Giphy/GiphyPreview';
import VimeoPreview from './Vimeo/VimeoPreview';
import GoogleMapsPreview from './GoogleMaps/GoogleMapsPreview';



const WebEmbedPreview = ({embedType, inputValue, setDisableUpload, showPreview, setIsLoading, isLoading, setEmbedId}: {embedType: EmbedType, inputValue: string, setDisableUpload: any, showPreview: boolean, setIsLoading:any, isLoading: boolean, setEmbedId: any}) => {

    if (!inputValue || !showPreview) {
        return <div className="spacer"/>
    }

    switch (embedType) {
        case EmbedType.YOUTUBE:
            return <YouTubePreview url={inputValue} setDisableUpload={(value: boolean) => setDisableUpload(value)} setIsLoading={(value: boolean) => setIsLoading(value)} isLoading={isLoading} setEmbedId={(embedId: string) => setEmbedId(embedId)}/>

        case EmbedType.GIPHY:
            return <GiphyPreview url={inputValue} setDisableUpload={(value: boolean) => setDisableUpload(value)} setIsLoading={(value: boolean) => setIsLoading(value)} isLoading={isLoading} setEmbedId={(embedId: string) => setEmbedId(embedId)}/>

        case EmbedType.GOOGLE_MAPS:
            return <GoogleMapsPreview url={inputValue} setDisableUpload={(value: boolean) => setDisableUpload(value)} setIsLoading={(value: boolean) => setIsLoading(value)} isLoading={isLoading} setEmbedId={(embedId: string) => setEmbedId(embedId)}/>

        case EmbedType.VIMEO:
            return <VimeoPreview url={inputValue} setDisableUpload={(value: boolean) => setDisableUpload(value)} setIsLoading={(value: boolean) => setIsLoading(value)} isLoading={isLoading} setEmbedId={(embedId: string) => setEmbedId(embedId)}/>

    }
}
export default WebEmbedPreview